module.exports = __webpack_public_path__ + "media/images/front/top/for_dental_hygienist-d11f88030d3d66026c81bea8a4874206.jpeg";